import * as types from './types';

export const createMessage = (data) => ({
	type: types.CREATE_SYSTEM_MESSAGE,
	payload: data
});

export const removeMessage = () => ({
	type: types.REMOVE_SYSTEM_MESSAGE
});
